import type { FullAttack, FullSkillEffect, FullSpecialEffect } from '../data/full';
import type { AttackModule } from './attacks/types';
import { charged } from './full/attacks/charged';
import { cascade } from './full/skills/cascade';
import { clubs, clubsGauge } from './full/attacks/clubs';
import { ball } from './full/attacks/ball';
import { ink } from './full/attacks/ink';
import { glowstick } from './full/attacks/glowstick';
import { fox } from './full/attacks/fox';
import { swarm } from './full/attacks/swarm';
import { shootingStar } from './full/attacks/shooting-star';
import { echo } from './full/attacks/echo';
import { circadian } from './full/attacks/circadian';
import { brood } from './full/attacks/brood';
import { cycle } from './full/attacks/cycle';
import { festival } from './full/festival';
import { elanGauge } from './full/gauges/elan';
import { racinesGauge } from './full/gauges/racines';
import { hibou } from './full/skills/hibou';
import { eclipse } from './full/skills/eclipse';
import { lanterne } from './full/skills/lanterne';
import { meteors } from './full/skills/meteors';
import { halfTime } from './full/skills/half-time';
import { debandade } from './full/skills/debandade';
import { dechaine } from './full/skills/dechaine';
import { motif } from './full/skills/motif';
import { rappel } from './full/skills/rappel';
import { beatArmor } from './full/beat-armor';
import { blackout, endBlackout } from './full/blackout';
import { heat } from './full/heat';
import { puddle } from './full/puddle';
import { sting } from './full/sting';
import { sprint } from './full/skills/sprint';
import type { GaugeModule } from './gauges';
import type { GameMode } from './mode';
import type { SkillModule } from './skills/types';
import type { SpecialModule } from './specials/types';
import { summonActions, summonBosses, tookPoseKey } from './full/summons';
import type { FullSteps } from './systems/types';

// The demo swaps in `full.demo.ts` (ADR 0015).
export const FULL_SPECIALS: Readonly<Record<FullSpecialEffect['kind'], SpecialModule>> = {
  puddle,
  heat,
  beatArmor,
  sting,
  blackout,
};
export const FULL_ATTACKS: {
  readonly [K in FullAttack['kind']]: AttackModule<Extract<FullAttack, { kind: K }>>;
} = {
  charged,
  clubs,
  ball,
  ink,
  glowstick,
  fox,
  swarm,
  shootingStar,
  echo,
  circadian,
  brood,
  cycle,
};
export const FULL_SKILLS: {
  readonly [K in FullSkillEffect['kind']]: SkillModule<Extract<FullSkillEffect, { kind: K }>>;
} = {
  cascade,
  sprint,
  motif,
  rappel,
  hibou,
  lanterne,
  meteors,
  halfTime,
  eclipse,
  debandade,
  dechaine,
};
export const FULL_GAUGES: Readonly<Record<string, GaugeModule>> = {
  clubs: clubsGauge,
  elan: elanGauge,
  racines: racinesGauge,
};
export const FULL_STEPS: FullSteps = {
  afterMovement: [summonActions, endBlackout],
  afterSpawning: [summonBosses],
  tookPoseKey,
};
export const FULL_MODES: { readonly festival?: GameMode } = { festival };
